import { render, staticRenderFns } from "./HijriParent.vue?vue&type=template&id=62f56126&"
import script from "./HijriParent.vue?vue&type=script&lang=js&"
export * from "./HijriParent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports